import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/mom/work-order/{id}/close`。僅 PROCESSING。body 僅 `updatedAt`。 */
export async function closeWorkOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mom/work-order/${id}/close`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
